import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, umsUrl } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { FAB_SURGE_CREATE_USER, FAB_SURGE_CREATE_USER_ERROR, FAB_SURGE_CREATE_USER_SUCCESS } from '../../../actions.js';
import cogoToast from 'cogo-toast';

function* createFabUser({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/client/register`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success('User created successfully');
      yield put({
        type: FAB_SURGE_CREATE_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: FAB_SURGE_CREATE_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FAB_SURGE_CREATE_USER_ERROR, payload: error });
  }
}

export function* watchCreateFabUser() {
  yield takeEvery(FAB_SURGE_CREATE_USER, createFabUser);
}

function* createFabUserSaga() {
  yield all([fork(watchCreateFabUser)]);
}

export default createFabUserSaga;
